module.exports = __webpack_public_path__ + "img/reset.da70ce0a.svg";